export default __webpack_public_path__ + "locales/ar-SA/InfoPanel.json?hash=a134c53124e5506b5eeac4c646927be8";